import { type WidthSettings } from '@blaze-runtime/engine-domain';

/** Used when a `fitContent` width omits `minWidth`. */
export const DEFAULT_FIT_CONTENT_MIN_WIDTH = 80;
/** Used when a `fixed` width omits `width`. */
export const DEFAULT_FIXED_WIDTH = 100;

interface FullWidthStyle {
  $type: 'full';
}

interface FitContentWidthStyle {
  $type: 'fitContent';
  minWidth?: number;
}

interface FixedWidthStyle {
  $type: 'fixed';
  width: number;
}

export type WidthStyle = FullWidthStyle | FitContentWidthStyle | FixedWidthStyle;

export function toWidthSettings(width: WidthStyle): WidthSettings {
  switch (width.$type) {
    case 'full':
      return {
        mode: 'full',
      };
    case 'fitContent':
      return {
        mode: 'value',
        value: width.minWidth ?? DEFAULT_FIT_CONTENT_MIN_WIDTH,
        fixed: false,
      };
    case 'fixed':
      return {
        mode: 'value',
        value: width.width ?? DEFAULT_FIXED_WIDTH,
        fixed: true,
      };
  }
}

/** Inverse of {@link toWidthSettings}. `auto`/fixed-value settings invert to `fixed` - lossy but harmless. */
export function toWidthStyle(width: WidthSettings): WidthStyle {
  if (width.mode === 'full') {
    return { $type: 'full' };
  }

  if (width.mode === 'value' && width.fixed === false) {
    return { $type: 'fitContent', minWidth: width.value };
  }

  if (width.value === undefined) {
    throw new Error('Missing element height');
  }

  return { $type: 'fixed', width: width.value };
}
